'use client';

import { Menu } from 'lucide-react';

type Props = {
  onOpen: () => void;
};

export default function MobileNavTrigger({ onOpen }: Props) {
  return (
    <button
      onClick={onOpen}
      className="flex xl:hidden items-center justify-center p-2"
      aria-label="Open menu"
    >
      <Menu size={28} />
    </button>
  );
}
